import { TextField, TextInput } from "react-admin";
import { RecordSummary, MyShow } from "../ra-lb-tools/components/MyShow";
import { useParams } from "react-router-dom";
import { TowerList } from "./tower/towers";
import BusinessIcon from "@mui/icons-material/Business";
import { FederationList } from "./federatios";
import {
  MyReferenceField,
  MyReferenceInput,
} from "../ra-lb-tools/components/myReference";
import { MyList } from "../ra-lb-tools/components/myList";
import {
  MyEdit as Edit,
  MyCreate as Create,
} from "../ra-lb-tools/components/myMutator";
import { LabeledColumn } from "../ra-lb-tools/components/labeledColumn";
import {
  MyTabbedShowLayout,
  Tab,
} from "../ra-lb-tools/components/myTabbedShowLayout";
import { LockerUsageList } from "./billing/lockerUsage";
import { UserField, UserInput } from "./users";

export const SystemIcon = BusinessIcon;

const filters = () => [
  <TextInput source="id" alwaysOn key="id" />,
  <TextInput source="name" alwaysOn key="name" />,
  <UserInput source="ownerId" allowEmpty alwaysOn key={4} />,
];

export const SystemList = (props) => (
  <MyList {...props} resource="systems" filters={filters()}>
    <TextField source="id" />
    <TextField source="name" />
    <TextField source="description" />
    <UserField source="ownerId" />
  </MyList>
);

export const SystemEdit = (props) => {
  return (
    <Edit {...props}>
      <TextInput source="id" disabled />
      <TextInput source="name" />
      <TextInput source="description" multiline />
    </Edit>
  );
};

export const SystemCreate = (props) => {
  return (
    <Create {...props}>
      <TextInput source="name" />
      <TextInput source="description" multiline />
    </Create>
  );
};

export const SystemShow = () => {
  const id = parseInt(useParams()["id"]);

  return (
    <MyShow>
      <MyTabbedShowLayout>
        <Tab label="Summary" can={true}>
          <RecordSummary>
            <LabeledColumn>
              <TextField source="id" />
              <TextField source="name" />
              <TextField source="description" />
              <UserField source="ownerId" />
            </LabeledColumn>
          </RecordSummary>
        </Tab>
        <Tab
          label="Towers"
          path="towers"
          can={{ action: "list", resource: "towers" }}
        >
          <TowerList filter={{ systemId: id }} filters={null} />
        </Tab>
        <Tab
          label="Retired Towers"
          path="towers-retired"
          can={{ action: "list", resource: "towers" }}
        >
          <TowerList filter={{ systemId: id, statusId: 4 }} filters={null} />
        </Tab>
        <Tab
          label="Locker Usage"
          path="locker-usage"
          can={{
            action: "list",
            resource: "locker-usage",
          }}
          key="locker-usage"
        >
          <LockerUsageList filter={{ systemId: id }} />
        </Tab>
        <Tab
          label="Federations"
          path="federations"
          can={{ action: "list", resource: "federations" }}
        >
          <FederationList filter={{ systemId: id }} />
        </Tab>
      </MyTabbedShowLayout>
    </MyShow>
  );
};

export const SystemInput = (props) => {
  return <MyReferenceInput source="systemId" reference="systems" {...props} />;
};

export const SystemField = (props) => {
  return <MyReferenceField source="systemId" reference="systems" {...props} />;
};
